const CopyLink = () => {
  const links = Array.from(document.querySelectorAll(".copy-link"));

  if (links.length > 0) {
    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const linkAttr = link.getAttribute("data-href");
        if (linkAttr) {
          navigator.clipboard.writeText(linkAttr);
        } else {
          const url = window.location.href;
          navigator.clipboard.writeText(url);
        }
      });
    });
  }
};

export default CopyLink;
